var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    style: {
      width: "100%",
      height: "100%",
      transform: "translate3d(0,0,0)",
      contentVisibility: "visible"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h524v524H0z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    "mask-type": "alpha"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)",
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    transform: "matrix(.15337 0 0 .15337 1.535 20.866)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F3B064",
    d: "M-.26 3.202a.43.43 0 0 0 .243.075h.001a.435.435 0 0 0 .418-.555C.202 1.841.295 1.133.681.62c.483-.644.697-1.471.572-2.212A2.345 2.345 0 0 0 .228-3.179a.445.445 0 0 0-.491.002.432.432 0 0 0-.176.457c.217.928.018 1.519-.482 2.418-.324.584-.457 1.241-.373 1.85A2.328 2.328 0 0 0-.26 3.202z",
    transform: "matrix(6.52 0 0 6.52 308.945 116.979)",
    style: {
      display: "block"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3B064",
    d: "M-.242 2.43a.408.408 0 0 0 .624-.448C.241 1.362.305.867.572.512c.369-.492.532-1.126.436-1.694a1.811 1.811 0 0 0-.793-1.226.41.41 0 0 0-.626.432c.154.658.019 1.06-.344 1.713-.248.447-.349.95-.285 1.416.074.535.351.977.798 1.277z",
    transform: "matrix(6.52 0 0 6.52 332.674 120.136)",
    style: {
      display: "block"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3B064",
    d: "M-.242 2.43a.403.403 0 0 0 .23.071h.001a.41.41 0 0 0 .393-.519C.242 1.362.306.868.572.512c.37-.492.532-1.125.436-1.694a1.805 1.805 0 0 0-.791-1.226.411.411 0 0 0-.627.433c.154.657.018 1.06-.345 1.713-.249.446-.35.949-.285 1.415.074.535.351.977.798 1.277z",
    transform: "matrix(6.52 0 0 6.52 285.167 120.135)",
    style: {
      display: "block"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#F3B064",
    d: "M9.064-7.382c-.478 0-1.156.098-1.805.535a12.918 12.918 0 0 0-.116-.237l-.018-.038c-.104-.216-.32-.666-1.254-.666h-16.465c-.351 0-.834.128-1.142.742a10.685 10.685 0 0 0-1.14 4.828c0 4.053 2.279 7.774 5.949 9.711.057.031.574.295 1.113.295h7.069a2.35 2.35 0 0 0 1.02-.252 11.281 11.281 0 0 0 4.03-3.494c.15.033.316.054.502.054 1.142 0 2.635-.718 3.804-1.826 1.461-1.387 2.265-3.231 2.265-5.195 0-2.458-1.71-4.457-3.812-4.457zM7.6 1.613a10.78 10.78 0 0 0 .478-6.042c.358-.693.769-.694.986-.694.841 0 1.553 1.007 1.553 2.198 0 2.557-1.836 4.017-3.017 4.538z",
    transform: "translate(51.249 52.992)",
    style: {
      display: "block"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChill);
export default __webpack_public_path__ + "static/media/chill.9a0feb8e424eea225cbcf6c9317c0dcf.svg";
export { ForwardRef as ReactComponent };